import "assets/scss/style.scss";

import { FC, useState } from "react";

import ConfirmEmail from "features/auth/components/ConfirmEmail";
import RegisterForm from "features/auth/components/RegisterForm";
import svgImage from "assets/img/Illustration_documents.svg";
import { useParams } from "react-router-dom";
import Footer from "components/Footer";

const Register: FC = () => {
    const { referralCode} = useParams();
    const { domainAssistant} = useParams(); // isNewUserFromWordpressAccompaniment
    const { offreIdFromWordpress} = useParams(); //offreIdFromWordpress

    const [showConfirmEmail, setShowConfirmEmail] = useState(false);
    const [confirmEmailMessage, setConfirmEmailMessage] = useState("");

    return (
        <main className="login">
            <div className="login__container">
                <div className="login__form">
                    {!showConfirmEmail && (
                        <RegisterForm
                            showConfirmEmail={setShowConfirmEmail}
                            setConfirmEmailMessage={setConfirmEmailMessage}
                            referralCode={referralCode}
                            isNewUserFromWordpressAccompaniment={domainAssistant === 'fwa'}
                            offreIdFromWordpress={Number(offreIdFromWordpress ?? '0')}
                        />
                    )}
                    {showConfirmEmail && <ConfirmEmail confirmEmailMessage={confirmEmailMessage} />}
                </div>
                <div className="login__img">
                    <img
                        src={svgImage}
                        className="illustration-document"
                        alt="Register"
                    />
                </div>
            </div>
            <Footer />
        </main>
    );
};

export default Register;
